import { BaseCustomerSurveyClient } from "../types/clients";
import { User } from "@core/types";
import { SupaCustomerSurveyCompletionsType } from "../../../../4time/src/shared/types/supabaseFragments";

class CustomerSurveyClient extends BaseCustomerSurveyClient {
  async getCustomerSurveyAnswers(userPhone: User["phone"]): Promise<SupaCustomerSurveyCompletionsType | null> {
    throw new Error("getCustomerSurveyAnswers not implemented");
  }
  async createCustomerSurveyAnswers(
    payload: Omit<SupaCustomerSurveyCompletionsType, "id" | "created_at">
  ): Promise<void> {
    throw new Error("createCustomerSurveyAnswers not implemented");
  }
}

export default CustomerSurveyClient;
